import axios from "axios";
import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import swal from "sweetalert";
import { API } from "../../../../API";
import { isAutheticated } from "../../../auth/authhelper";
import ClipLoader from "react-spinners/ClipLoader";
import Footer from "../../Footer";

function AddCategory() {
  const [inputText, setInputText] = useState("");
  const [loading, setLoading] = useState(false);
  const [nameLen, setNameLen] = useState(50);

  const history = useHistory();
  const { token } = isAutheticated();
  const wordLimit = 50;

  const handleChange = (e) => {
    const value = e.target.value;
    if (value.length <= wordLimit) {
      setInputText(value);
      setNameLen(wordLimit - value.length);
    }
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    if (inputText.trim() === "") {
      swal({
        title: "Enter Category Name",
        icon: "warning",
        button: "Close",
      });
      return;
    }

    setLoading(true);

    try {
      const res = await axios.post(
        `${API}/api/category/`,
        { category: inputText.trim() },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      swal({
        title: res?.data?.message || "Category added successfully",
        icon: "success",
        button: "OK",
      }).then(() => history.push("/comcatagory"));
    } catch (err) {
      const message =
        err?.response?.data?.message || "Something went wrong, please try again.";
      swal({
        title: message,
        icon: "warning",
        button: "Close",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          {/* Page title */}
          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0">OTT Shop - Categories</h4>
                <div className="page-title-right">
                  <ol className="breadcrumb m-0">
                    <li className="breadcrumb-item">
                      <Link to="/dashboard">SoComOTT</Link>
                    </li>
                    <li className="breadcrumb-item">OTT Shop - Categories</li>
                    <li className="breadcrumb-item active">Add New</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* Form */}
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="col-md-12 col-lg-6">
                    <h1 className="text-left head-small">Add New Category</h1>

                    <form onSubmit={submitHandler}>
                      <div className="form-group">
                        <label className="label-100">Enter Category Name</label>
                        <input
                          type="text"
                          className="form-control input-field"
                          value={inputText}
                          onChange={handleChange}
                        />
                        <small className="text-muted">
                          Remaining characters: {nameLen}
                        </small>
                      </div>

                      <div className="form-group text-left mt-3">
                        <button
                          type="submit"
                          className="btn btn-success btn-login waves-effect waves-light mr-3"
                          disabled={loading}
                        >
                          <ClipLoader loading={loading} size={18} color="#fff" />
                          {!loading && "Save"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default AddCategory;
